import "./Invoices.scss";

const Invoice = ({ invoices }) => {
  if (!invoices) return <p>No invoice data.</p>;

  const {
    Bill_ID,
    Date,
    Location,
    Item_Selected = [],
    Tax,
    originalTotal,
  } = invoices;

  const taxRate = parseFloat(Tax) / 100 || 0;
  const taxAmount = originalTotal * taxRate || 0;
  const finalTotal = originalTotal + taxAmount;

  const allItems = Item_Selected.flatMap((item) => {
    const itemRow = {
      name: item.name,
      price: item.price,
      quantity: item.quantity,
      total: item.total,
      type: item.type,
    };
    const toppingRows =
      item.toppings?.map((t) => ({
        name: t.name,
        price: t.price,
        quantity: t.quantity,
        total: t.price,
        type: "Topping",
      })) || [];
    return [itemRow, ...toppingRows];
  });


  return (
    <div className="invoice-wrapper">
      <div className="invoice-container">
        <div className="invoice-main-content">
          <h2 className="invoice-title">PopPay System</h2>
          <p className="invoice-address">{Location}</p>
          <p className="invoice-phone">0338.998.047</p>
          <div className="invoice-divider" />

          <div className="invoice-header">
            <p className="invoice-date">{Date}</p>
            <h3>Invoice</h3>
            <p className="invoice-id">{Bill_ID}</p>
          </div>

          <table className="invoice-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Price</th>
                <th>Quantity</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {allItems.map((item, idx) => (
                <tr key={`${item.name}-${idx}`} className={item.type === "Topping" ? "topping-row" : ""}>
                  <td>{item.name}</td>
                  <td>${(item.price ?? 0).toFixed(2)}</td>
                  <td>{item.quantity}</td>
                  <td>${(item.total ?? 0).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="invoice-summary-container">
            <div className="invoice-summary">
              <p>Provisional: ${(originalTotal || 0).toFixed(2)}</p>
              <p>Tax: ${(taxAmount || 0).toFixed(2)}</p>
              <p className="invoice-total">
                Final Total: <strong>${(finalTotal || 0).toFixed(2)}</strong>
              </p>
            </div>
          </div>
        </div>

        <div className="invoice-footer">
          Thank you very much. We hope to see you again!
        </div>
      </div>
    </div>
  );
};

export default Invoice;
